module.exports = __webpack_public_path__ + "img/descr-mod-fatturazione-emt.687607d5.png";